import { defineTexts } from "@khol/utils/languages/defineTexts";

/**
 * Copy for the announcements declared in `announcements.ts`.
 *
 * Each announcement owns four keys, prefixed with its id: `<id>Title` (what shipped), `<id>Body`
 * (what it does), `<id>Where` (where to find it — the whole point of the component) and `<id>Cta`
 * (the link label). `getAnnouncementTexts` in `index.tsx` reads them by that convention.
 */
export default defineTexts({
  heading: {
    en: "New",
    fr: "Nouveau",
    he: "חדש",
  },
  dismiss: {
    en: "Close",
    fr: "Fermer",
    he: "סגור",
  },
  modalTitle: {
    en: "What's new",
    fr: "Nouveautés",
    he: "מה חדש",
  },
  acknowledge: {
    en: "Got it",
    fr: "J'ai compris",
    he: "הבנתי",
  },
  next: {
    en: "Next",
    fr: "Suivant",
    he: "הבא",
  },
  back: {
    en: "Back",
    fr: "Précédent",
    he: "הקודם",
  },
  stepOf: (current: number, total: number) => ({
    en: `${current} of ${total}`,
    fr: `${current} sur ${total}`,
    he: `${current} מתוך ${total}`,
  }),

  // dafSuggestion — next-daf suggestion and duplicate warning in the Add video form.
  dafSuggestionTitle: {
    en: "Daf Hayomi titles now suggest themselves",
    fr: "Les titres du Daf Hayomi se suggèrent tout seuls",
    he: "כותרות הדף היומי מוצעות אוטומטית",
  },
  dafSuggestionBody: {
    en: "Pick the Daf Hayomi category and the form proposes the next daf of the massekhet you were last working through — one click fills the title. It also warns you when the daf you typed has already been uploaded.",
    fr: "Choisissez la catégorie Daf Hayomi et le formulaire propose le daf suivant de la massekhet sur laquelle vous travailliez — un clic remplit le titre. Il vous avertit aussi si le daf saisi a déjà été mis en ligne.",
    he: "בחרו בקטגוריית דף יומי והטופס יציע את הדף הבא של המסכת שבה עסקתם לאחרונה — לחיצה אחת ממלאת את הכותרת. הוא גם מתריע אם הדף שהקלדתם כבר הועלה.",
  },
  dafSuggestionWhere: {
    en: "Videos management → Add video → Title field",
    fr: "Gestion des vidéos → Ajouter une vidéo → champ Titre",
    he: "ניהול סרטונים ← הוסף סרטון ← שדה הכותרת",
  },
  dafSuggestionCta: {
    en: "Open video management",
    fr: "Ouvrir la gestion des vidéos",
    he: "פתח את ניהול הסרטונים",
  },

  // titleFromFile — title derived from the uploaded file name.
  titleFromFileTitle: {
    en: "Uploading a file names the video for you",
    fr: "Le téléversement d'un fichier nomme la vidéo pour vous",
    he: "העלאת קובץ ממלאת את שם הסרטון",
  },
  titleFromFileBody: {
    en: "Select a video file and the title is filled from the file name, so an empty title is no longer something to remember. It is only ever a starting point — edit or replace it before saving.",
    fr: "Sélectionnez un fichier vidéo et le titre est rempli à partir du nom du fichier : plus besoin d'y penser. Ce n'est qu'un point de départ — modifiez-le ou remplacez-le avant d'enregistrer.",
    he: "בחרו קובץ וידאו והכותרת תתמלא משם הקובץ, כך שאין עוד צורך לזכור למלא אותה. זו רק נקודת התחלה — ניתן לערוך או להחליף לפני השמירה.",
  },
  titleFromFileWhere: {
    en: "Videos management → Add video → Upload a video file",
    fr: "Gestion des vidéos → Ajouter une vidéo → Téléverser un fichier vidéo",
    he: "ניהול סרטונים ← הוסף סרטון ← העלאת קובץ וידאו",
  },
  titleFromFileCta: {
    en: "Open video management",
    fr: "Ouvrir la gestion des vidéos",
    he: "פתח את ניהול הסרטונים",
  },
});
